export const CommonNS = 'common';
export const DeviceNS = 'device';
export const MeasurementsNS = 'measurements';
export const InventoryNS = 'inventory';
